module.exports = __webpack_public_path__ + "static/media/7.db410660.jpg";